module.exports = __webpack_public_path__ + "th.svg?8b6e38c84956db8538df8fb8fcfae939";